module.exports = __webpack_public_path__ + "img/Facilities_request.b6d4531b.svg";